// What a recording's delivery receipt says landed in the customer's bucket.
// The server projects it for the recording's owner (and staff admins, who also
// get ETags and a destination fingerprint); nothing here grants visibility.
const deliverySelection = `delivery {
  completedAt includesHls includesRaw fileCount totalBytes
  artifacts { name kind bytes etag }
  destinationFingerprint
}`;

const KIND_LABELS = { final: 'Recording', hls: 'HLS', raw: 'Raw' };

const formatBytes = (bytes) => {
  const n = Number(bytes);
  if (!Number.isFinite(n) || n < 0) return '—';
  if (n < 1024) return `${n} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let value = n / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) { value /= 1024; unit += 1; }
  return `${value >= 100 ? Math.round(value) : value.toFixed(1)} ${units[unit]}`;
};

// One line per kind: the final file(s) by name, HLS and raw as counts, since a
// stream can deliver hundreds of segments.
const deliveryView = (delivery) => {
  if (!delivery || !Array.isArray(delivery.artifacts) || !delivery.artifacts.length) return null;
  const groups = ['final', 'hls', 'raw'].map((kind) => {
    const items = delivery.artifacts.filter((a) => a?.kind === kind);
    return items.length ? { kind, label: KIND_LABELS[kind], items,
      count: items.length, bytes: items.reduce((sum, a) => sum + (Number(a.bytes) || 0), 0) } : null;
  }).filter(Boolean);
  const total = Number(delivery.totalBytes) || groups.reduce((sum, g) => sum + g.bytes, 0);
  const count = Number(delivery.fileCount) || delivery.artifacts.length;
  return {
    summary: `${count} ${count === 1 ? 'file' : 'files'} · ${formatBytes(total)}`,
    completedAt: delivery.completedAt || null,
    groups,
    fingerprint: delivery.destinationFingerprint || null,
  };
};

module.exports = { deliverySelection, formatBytes, deliveryView };
